
import { defineComponent } from "vue";

export default defineComponent({
  name: "confirmation-modal",
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
});
